import React from 'react';

interface CrossIconProps extends React.SVGProps<SVGSVGElement> {
    addShadow?: boolean;
}

const CrossIcon: React.SFC<CrossIconProps> = ({addShadow = false, ...rest}) => {
    const cutoffSize = addShadow ? 33.65 : 27.65;
    return (
        <svg viewBox={`0 0 ${cutoffSize} ${cutoffSize}`} {...rest}>
            {addShadow &&
                <defs>
                    <filter id="shadow" width="150%" height="150%">
                        <feFlood floodColor="#001722" result="color" />
                        <feComposite operator="in" in="color" in2="SourceGraphic" result="coloredCopy"/>
                        <feGaussianBlur stdDeviation={2.5} in="coloredCopy" result="dropShadow" />
                        <feMerge>
                            <feMergeNode in="dropShadow" />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                    </filter>
                </defs>
            }
            <path
                fill="currentColor"
                filter={addShadow ? 'url(#shadow)' : undefined}
                transform={addShadow ? 'translate(3 3)' : undefined}
                // tslint:disable-next-line:max-line-length
                d="M13.895 10.618L4.984 1.707 3.345.068.068 3.345l1.639 1.639 8.911 8.911-8.911 8.912-1.639 1.639 3.277 3.277 1.639-1.639 8.911-8.911 8.912 8.911 1.639 1.639 3.277-3.277-1.639-1.639-8.911-8.912 8.911-8.911 1.639-1.639L24.446.068l-1.639 1.639-8.912 8.911z"
            />
        </svg>
    );
};

export { CrossIcon };
